export class RentalStockModel {
  articleId: number = 0;
  articleCode: number = 0;
  articleAlterCode: string | null = null;
  articleName: string = "";
  articleTypeArticleId: number = 0;
  articleActive: boolean = false;
  storeId: number = 0;
  storeCode: number = 0;
  storeName: string = "";
  stock: number = 0;
  availableStock: number = 0;

  predevolutionQuantity: number = 0;
  dateMovement: Date = new Date();

  //Pedidos
  remissionId: number = 0;
  orderDetailId: number = 0;
  internalOrderDetailId: number | null = null;
  orderId: number = 0;
  internalOrderId: number = 0;
  orderCode: number = 0;
  internalOrderCode: number = 0;
  orderStateId: number = 0;
  orderStateName: string = "";
  swGeneric: boolean = false;
  genericId: number = 0;
  quantity: number = 0;
  quantityFinal: number = 0;
  quantityPending: number = 0;
  quantityRemission: number = 0;
}
